import { useToast, ToastPosition } from '@chakra-ui/react';
import CustomToastRender from 'components/Toast/CustomToastRender';

const useCustomToast = () => {
  const toast = useToast();

  const showToast = (status: 'success' | 'error' | 'warning' | 'info', customText?: string, options?: { duration?: number; position?: ToastPosition, allowHtml: boolean, testId?: string; }) => {
    const { duration = 9000, position = 'top-right', allowHtml } = options || {};

    toast({
      position,
      duration,
      render: ({ onClose }) => (
        <CustomToastRender status={status} onClose={onClose} customText={customText} allowHtml={allowHtml} data-testid={options?.testId} />
      ),
    });
  };

  return { showToast };
};

export default useCustomToast;
